// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__61ChR","col":"CardReaderDesc_col__CWxqZ","label":"CardReaderDesc_label__1Wnuu"};